import gql from 'graphql-tag';

export const updateEquipmentMutation = gql(/* GraphQL */ `
  mutation updateEquipmentMutation($updateEquipment: UpdateEquipmentInput) {
    updateEquipment(equipment: $updateEquipment) {
      id
    }
  }
`);
